// Admin image pinpoint js
document.addEventListener('livewire:init', function () {
  this.addEventListener('click', e => {
    const pinpointContainer = e.target.closest('[data-pinpoint-image-container]');

    if (pinpointContainer) {
      const x = e.offsetX, y = e.offsetY, width = e.target.width, height = e.target.height;

      document.querySelector('[data-new-pinpoint-loading]')?.classList.remove('d-none');

      Livewire.dispatch('addPinpoint', {x, y, width, height});
    }
  });
});

// Client image pinpoint js
document.addEventListener('DOMContentLoaded', function () {
  const pinpoints = document.querySelectorAll('[data-pinpoint-in-admin="false"]');
  const infoCards = document.querySelectorAll('[data-pinpoint-info-id]');
  const pinpointCloseButtons = document.querySelectorAll('[data-pinpoint-close]');

  const initialHeight = document.body.offsetHeight;

  // fire an event to the parent window with the height the iframe should be
  window.parent.postMessage({
    origin: 'Pinpoint-Image',
    resize: true,
    load: true,
    initialHeight,
    windowWidth: window.innerWidth,
  }, '*');

  pinpoints.forEach(pinpoint => {
    pinpoint.addEventListener('click', e => {
      let opening = true;
      let infoCardHeight = 0;

      // get the height of an info card
      const targetId = e.target.dataset.pinpointId;

      // reset all pinpoints, except the one that was clicked
      pinpoints.forEach(pinpoint => {
        if (pinpoint.dataset.pinpointId !== targetId) {
          pinpoint.dataset.open = 'false'
        }
      });

      // reset all info cards, except the one that was clicked
      infoCards.forEach(card => {
        if (card.dataset.pinpointInfoId !== targetId) {
          card.classList.add('info-card-showing');

          setTimeout(() => {
            card.classList.add('info-card-hidden')
            card.classList.remove('info-card-showing');
          }, 250);
        }
      });

      if (e.target.dataset.open === 'true') {
        opening = false;

        e.target.dataset.open = 'false';
        infoCards.forEach(card => {
          if (card.dataset.pinpointInfoId === targetId) {
            card.classList.add('info-card-showing');

            setTimeout(() => {
              card.classList.add('info-card-hidden')
              card.classList.remove('info-card-showing');
            }, 250);
          }
        });
      } else {
        e.target.dataset.open = 'true';
        infoCards.forEach(card => {
          if (card.dataset.pinpointInfoId === targetId) {
            card.classList.add('info-card-showing');
            card.classList.remove('info-card-hidden');
            card.classList.add('info-card-mobile-z-fix');

            setTimeout(() => {
              card.classList.remove('info-card-showing');
            }, 50);

            setTimeout(() => {
              card.classList.remove('info-card-mobile-z-fix');
            }, 350);
          }
        });
      }

      // get the height of the info card
      infoCards.forEach(card => {
        if (card.dataset.pinpointInfoId === targetId) {
          infoCardHeight = card.offsetHeight;
        }
      });

      // fire an event to the parent window
      window.parent.postMessage({
        origin: 'Pinpoint-Image',
        resize: true,
        opening,
        resizeHeight: infoCardHeight,
        windowWidth: window.innerWidth,
        initialHeight,
      }, '*');
    });
  });

  pinpointCloseButtons.forEach(button => {
    button.addEventListener('click', e => {
      const pinpointId = e.target.dataset.pinpointClose;

      pinpoints.forEach(pinpoint => {
        if (pinpoint.dataset.pinpointId === pinpointId) {
          pinpoint.dataset.open = 'false';
        }
      });

      infoCards.forEach(card => {
        if (card.dataset.pinpointInfoId === pinpointId) {
          card.classList.add('info-card-showing');

          setTimeout(() => {
            card.classList.add('info-card-hidden')
            card.classList.remove('info-card-showing');
          }, 250);
        }
      });

      // fire an event to the parent window
      window.parent.postMessage({
        origin: 'Pinpoint-Image',
        resize: true,
        opening: false,
        // resizeHeight: infoCardHeight,
        windowWidth: window.innerWidth,
        initialHeight,
      }, '*');
    });
  });
});
